import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumOrderSource implements BaseEnumType {
  private static allValues: EnumOrderSource[] = []; // make sure this is top-most
  
  public static none = new EnumOrderSource(0, "None", "enum_order_source_none");
  public static brewMan = new EnumOrderSource(1, "BrewMan", "enum_order_source_brew_man");
  public static wooCommerce = new EnumOrderSource(2, "WooCommerce", "enum_order_source_woo_commerce");
  public static shopify = new EnumOrderSource(3, "Shopify", "enum_order_source_shopify");
  public static sellar = new EnumOrderSource(4, "Sellar", "enum_order_source_sellar");
  public static zettle = new EnumOrderSource(5, "Zettle", "enum_order_source_zettle");
  public static other = new EnumOrderSource(6, "Other", "enum_order_source_other");
  public static eposNow = new EnumOrderSource(7, "EposNow", "enum_order_source_epos_now");
  public static beerflex = new EnumOrderSource(8, "Beerflex", "enum_order_source_beerflex");
  public static square = new EnumOrderSource(9, "Square", "enum_order_source_square");
  public static squarespace = new EnumOrderSource(10, "Squarespace", "enum_order_source_squarespace");
  public static ecwid = new EnumOrderSource(11, "Ecwid", "enum_order_source_ecwid");
  public static eeBria = new EnumOrderSource(12, "EeBria", "enum_order_source_ee_bria");
  public static commerce7 = new EnumOrderSource(13, "Commerce7", "enum_order_source_commerce7");
  public static tradePortal = new EnumOrderSource(14, "TradePortal", "enum_order_source_trade_portal");
  public static amazon = new EnumOrderSource(15, "Amazon", "enum_order_source_amazon");
  public static bigCommerce = new EnumOrderSource(16, "BigCommerce", "enum_order_source_big_commerce");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumOrderSource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumOrderSource.none; }
  public isBrewMan() { return this === EnumOrderSource.brewMan; }
  public isWooCommerce() { return this === EnumOrderSource.wooCommerce; }
  public isShopify() { return this === EnumOrderSource.shopify; }
  public isSellar() { return this === EnumOrderSource.sellar; }
  public isZettle() { return this === EnumOrderSource.zettle; }
  public isOther() { return this === EnumOrderSource.other; }
  public isEposNow() { return this === EnumOrderSource.eposNow; }
  public isBeerflex() { return this === EnumOrderSource.beerflex; }
  public isSquare() { return this === EnumOrderSource.square; }
  public isSquarespace() { return this === EnumOrderSource.squarespace; }
  public isEcwid() { return this === EnumOrderSource.ecwid; }
  public isEeBria() { return this === EnumOrderSource.eeBria; }
  public isCommerce7() { return this === EnumOrderSource.commerce7; }
  public isTradePortal() { return this === EnumOrderSource.tradePortal; }
  public isAmazon() { return this === EnumOrderSource.amazon; }
  public isBigCommerce() { return this === EnumOrderSource.bigCommerce; }

  public static getValues(): readonly EnumOrderSource[] {
    return EnumOrderSource.allValues;
  }

  public static getValuesExcept0(): readonly EnumOrderSource[] {
    return EnumOrderSource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumOrderSource {
    const found = EnumOrderSource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumOrderSource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumOrderSource): EnumOrderSource {
    const found = name ? EnumOrderSource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumOrderSource - Value not found: ${ name }`);
    }

    return found;
  }
}